import { searchIndicesV1, searchIndicesV2 } from './searchIndices';
export function resolveAlgoliaSearchIndex(environment) {
  let enableV2SearchIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const index = enableV2SearchIndex ? searchIndicesV2 : searchIndicesV1;
  return index[environment].indexName;
}